(() => {
  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const quizLink = event.target.closest('#sidebar-menu a[href="#quiz"]');

      if (!quizLink) {
        return;
      }

      const sidebar = quizLink.closest('header-sidebar');

      if (sidebar?.open) {
        sidebar.hide();
      }
    },
    { capture: true }
  );
})();
